import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import MarketingSales from "@/pages/MarketingSales";

export const Route = createFileRoute("/octopus")({
  head: () => routeHead('AGAPE Octopus — B2B Sales Engine', META_DESCRIPTIONS.octopus.en, '/octopus'),
  component: MarketingSales,
});
